module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$root.width < 770) ? _c('section', {
    staticClass: "p-home u-fit-w u-bg--black",
    attrs: {
      "width": _vm.$root.width,
      "touch": _vm.$root.isTouch
    }
  }, [_c('app-home-mobile'), _vm._v(" "), _c('app-footer')], 1) : _c('section', {
    staticClass: "p-home u-fit-w u-viewport-h u-overflow-h u-bg--black",
    class: [_vm.lastActiveIndex !== null ? 'is-slide-change' : '', 'is-active-index-' + _vm.activeIndex, 'is-active-level-' + _vm.activeLevel],
    on: {
      "DOMMouseScroll": _vm.onMouseWheel,
      "mousewheel": _vm.onMouseWheel
    }
  }, [_vm._l((_vm.slides), function(slide, index) {
    return _c('app-home-slide', {
      key: index,
      staticClass: "u-absolute u-pos-l u-fit u-overflow-h",
      class: ['c-home-slide--' + index, slide.nbLevels !== 0 && _vm.activeLevel !== 0 ? 'is-level-' + _vm.activeLevel : ''],
      attrs: {
        "activeIndex": _vm.activeIndex,
        "lastActiveIndex": _vm.lastActiveIndex,
        "index": index,
        "activeLevel": _vm.activeLevel,
        "nbLevels": slide.nbLevel
      }
    }, [(index === 0) ? _c('app-home-slide-0', {
      attrs: {
        "activeIndex": _vm.activeIndex,
        "activeLevel": _vm.activeLevel
      }
    }) : (index === 1) ? _c('app-home-slide-2', {
      attrs: {
        "activeIndex": _vm.activeIndex,
        "activeLevel": _vm.activeLevel
      }
    }) : (index === 2) ? _c('app-home-slide-1', {
      attrs: {
        "activeIndex": _vm.activeIndex,
        "activeLevel": _vm.activeLevel
      }
    }) : (index === 3) ? _c('app-home-slide-3', {
      attrs: {
        "activeIndex": _vm.activeIndex,
        "activeLevel": _vm.activeLevel
      }
    }) : (index === 4) ? _c('app-home-slide-4', {
      attrs: {
        "activeIndex": _vm.activeIndex,
        "activeLevel": _vm.activeLevel
      }
    }) : (index === 5) ? _c('app-home-slide-5', {
      attrs: {
        "activeIndex": _vm.activeIndex,
        "activeLevel": _vm.activeLevel
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('app-home-footer', {
    attrs: {
      "activeIndex": _vm.activeIndex,
      "activeLevel": _vm.activeLevel,
      "activeNbLevels": _vm.activeNbLevels,
      "NBSLIDE": _vm.slides.length
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "p-home__sound u-absolute u-zindex-1",
    class: [_vm.soundIsActive ? 'is-active' : '', _vm.soundHidden ? 'is-hidden' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onSoundClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "p-home__sound-theme p-home__sound-theme--black u-absolute u-fit",
    class: [_vm.theme === 'black' ? 'is-active' : '']
  }, [_c('div', {
    staticClass: "p-home__sound-border u-absolute"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-home__sound-icon u-absolute"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-home__sound-bar u-absolute"
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-home__sound-theme p-home__sound-theme--white u-absolute u-fit",
    class: [_vm.theme === 'white' ? 'is-active' : '']
  }, [_c('div', {
    staticClass: "p-home__sound-border u-absolute"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-home__sound-icon u-absolute"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-home__sound-bar u-absolute"
  })])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f4c50a4"}!./src/scripts/components/page-home/template.html
// module id = 457
// module chunks = 0